// extracted by mini-css-extract-plugin
export default {"card":"BI_jxaR1"};